import React, { useState } from "react";
// import {
//   useNavigate,
//   useParams,
// } from "react-router-dom";
import { Form, Label, Input, FormGroup, Button, Row, Col } from "reactstrap";
import "../form.css";
import "bootstrap/dist/css/bootstrap.css";
import WorkoutApi from "../Api";

const SetForm = ({ e_id }) => {
  // let { workout_id, exercise } = useParams();

  // const navigate = useNavigate();

  const INITIAL_STATE = {
    type_of_measurement: "",
    set_reps: "",
    set_weight: "",
    note: "",
  };

  const [fData, setFormData] = useState(INITIAL_STATE);
  const weight_type = [" ", "lb", "kg", "min", "bw"];

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData((fData) => ({
      ...fData,
      [name]: value,
    }));
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    WorkoutApi.createSet(e_id, { set: { ...fData } }).then((res) => {
      console.log(res);
    });

    alert(
      ` user ${fData.name_of_exercise}, password ${fData.exercise_description}`,
    );
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row className="row-cols-lg-auto g-3 align-items-center">
          <Col>
            <FormGroup>
              <Label className="labelTitle" htmlFor="type_of_measurement">
                Weight Type
              </Label>
              <Input
                id="type_of_measurement"
                name="type_of_measurement"
                placeholder="Create a name for your workout here"
                type="select"
                value={fData.type_of_measurement}
                onChange={handleChange}
              >
                {weight_type.map((w) => (
                  <option>{w}</option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="labelTitle" htmlFor="set_reps">
                Reps
              </Label>
              <Input
                id="set_reps"
                name="set_reps"
                placeholder="Reps"
                type="number"
                min="0"
                max="100"
                value={fData.set_reps}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="labelTitle" htmlFor="set_weight">
                Weight
              </Label>
              <Input
                id="set_weight"
                name="set_weight"
                placeholder="Weight"
                type="number"
                min="0"
                max="1000"
                value={fData.set_weight}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="labelTitle" htmlFor="note">
                Note
              </Label>
              <Input
                id="note"
                name="note"
                placeholder="Describe your workout here"
                type="text"
                value={fData.note}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col>
            <Button color="primary">Create a Set</Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default SetForm;
